export default __webpack_public_path__ + "static/media/siam11.c99bcaf6.jpg";